import { IApplicant, ApplicantsService, EnumService } from "../../../services/index";
import * as moment from 'moment';

interface IResolve {
    applicant: IApplicant;
    preferredTargetAudiences: any;
    applicationStatuses: any;
    functions: any;
    users: any;
}

class ApplicantsItemBasicController {

    private resolve: IResolve;
    private applicant: IApplicant;
    private preferredTargetAudiences: any;
    private applicationStatuses: any;
    private functions: any;
    users: any;

    constructor(
        private EnumService: EnumService,
        private ApplicantsService: ApplicantsService,
        private $state: ng.ui.IStateService
    ) {
        'ngInject';
    }


    public $onInit = () => {    
        this.applicant = this.resolve.applicant;
        this.preferredTargetAudiences = this.resolve.preferredTargetAudiences;
        this.applicationStatuses = this.resolve.applicationStatuses;
        this.functions = this.resolve.functions;
        this.users = this.resolve.users;

        this.users.forEach(user => {
            user.id = user.id.toLowerCase();
        });

        this.applicant.userId = this.applicant.userId.toLowerCase();
    }

    public save = () => {
        this.applicant.date = moment(this.applicant.date).format("YYYY-MM-DD HH:mm");
        
        if (this.applicant.id != undefined) {
            this.ApplicantsService.put(this.applicant.id, this.applicant).then((applicant: IApplicant) => {
                 this.closeModal();
            });
        } else {
            this.ApplicantsService.post(this.applicant).then((applicant: IApplicant) => {
                this.$state.go('^', { 'id': applicant.id });
            });
        }
    }

    private closeModal() {
        this.$state.go('^', {}, { reload: true });
    }
}

export const applicantsItemBasicComponent = { 
    bindings: {
        resolve : "<",
        close: "&"
    },
    controller: ApplicantsItemBasicController,
    template: require('./applicants.item.basic.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/hr/applicants/applicants.item.basic.component.ts